import {VIcon, VRating} from 'vuetify/lib'
import moment from 'moment';

import styles from '../style.module.less'
export default {
    props: {
        value: {
            type: Object,
        },
        showList: {
            type: Array,
            default:() => []
        },
        isFlex: {
            type: Boolean
        }
    },
    computed: {
        amount_effect() {
            return this.value.amount_effect || {}
        },
        first_week_effect() {
            return this.value.first_week_effect || {}
        },
        ratingToNumber() {
            const {attitude_rating, content_rating, other_evaluation} = this.value
            return {
                    attitude_rating:Number(attitude_rating), 
                    content_rating:Number(content_rating), 
                    other_evaluation:Number(other_evaluation) } 
        }
    },
    render() {
        return <div style={{
            display: this.isFlex ? 'flex' : 'block'
        }}>
            {this.showList.includes(1) && <div class={styles['effect-contain']} style={{
            flex: this.isFlex ? '1' : 'none'
        }}>
                <p class={styles['p-c']}>累计效果：</p>
                {/* p-c-i */}
                <div class={styles['t-l']}>
                    <span class={styles['p-c-i']}>
                        
                        <VIcon color="orange darken-2" small>mdi-thumb-up</VIcon>:{this.amount_effect.like_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="blue darken-2" small>mdi-comment</VIcon>:{this.amount_effect.comment_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="#FFD600" small>mdi-star</VIcon>:{this.amount_effect.favorite_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="deep-orange darken-1" small>mdi-play-circle</VIcon>:{this.amount_effect.view_num}
                    </span> 
                </div>
                <p class={styles['p-c']}>更新时间： {this.amount_effect.updated_at ? moment(this.amount_effect.updated_at).format('YYYY-MM-DD HH:mm') : '-'}</p>
            </div>}
            {this.showList.includes(2) && <div class={styles['effect-contain']} style={{
                flex: this.isFlex ? '1' : 'none'
            }}>
                <p class={styles['p-c']}>7天效果：</p>
                <div class={styles['t-l']}>
                <span class={styles['p-c-i']}>
                        
                        <VIcon color="orange darken-2" small>mdi-thumb-up</VIcon>:{this.first_week_effect.like_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="blue darken-2" small>mdi-comment</VIcon>:{this.first_week_effect.comment_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="#FFD600" small>mdi-star</VIcon>:{this.first_week_effect.favorite_num}
                    </span> 
                    <span class={styles['p-c-i']}>
                        <VIcon color="deep-orange darken-1" small>mdi-play-circle</VIcon>:{this.first_week_effect.view_num}
                    </span> 
                </div>
                <p class={styles['p-c']}>更新时间： {this.first_week_effect.updated_at ? moment(this.first_week_effect.updated_at).format('YYYY-MM-DD HH:mm') : '-'}</p>
            </div>}
            {this.showList.includes(3) && <div class={styles['effect-contain']} style={{
                    flex: this.isFlex ? '1' : 'none'
                }}>
                <div class={styles['t-l']}>
                    <p class={[styles['p-c'], styles['l-h-20']]} >
                        <span class={styles['s-w']}>是否拖稿</span>：<span class={this.value.delayed ? 'color-error' : 'color-success'}>{this.value.delayed ? '是' : '否'}</span>
                    </p>
                    <p class={[styles['p-c'], styles['l-h-20']]} >
                        <span class={styles['s-w']}>合作态度</span>：<VRating size="18" readonly v-model={this.ratingToNumber.attitude_rating} style="display:inline-block" />
                    </p>
                    <p class={[styles['p-c'], styles['l-h-20']]} >
                        <span class={styles['s-w']}>内容创造能力 </span>：<VRating size="18" readonly v-model={this.ratingToNumber.content_rating} style="display:inline-block" />
                    </p>
                    <p class={[styles['p-c'], styles['l-h-20']]} >
                        <span class={styles['s-w']}>其它 </span>：{this.value.other_evaluation}
                    </p>
                </div>
            </div>}
        </div>
    }
}